"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithTooltip = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@mantine/core");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function IconWithTooltip(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Tooltip, { label: props.text },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon }))));
}
exports.IconWithTooltip = IconWithTooltip;
//# sourceMappingURL=IconWithTooltip.js.map